module.exports = __webpack_public_path__ + "static/media/hero.9fea3158.mov";